/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit';
// api
import { decodeQrcode, decodeQrcodePublic } from '../../api/interviewSign';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  editInfo: null,
  errorToken: null,
  tokenResult: {
    first: null,
    second: null,
  },
};

const slice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    getEditInfo(state, action) {
      state.isLoading = false;
      state.editInfo = action.payload;
    },
    setError(state, action) {
      state.isLoading = false;
      state.errorToken = action.payload;
    },
    setTokenResult(state, { payload }) {
      const { key, value } = payload;
      state.isLoading = false;
      state.tokenResult[key] = value;
    },
    clearInfo(state) {
      state.editInfo = null;
    },
    resetError(state) {
      state.tokenResult = {
        first: null,
        second: null,
      };
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { clearInfo, resetError, setError } = slice.actions;
// ----------------------------------------------------------------------
// 获取面试表格列表
export function validToken(parms) {
  return async (dispatch) => {
    const { callback, ...rest } = parms;
    dispatch(slice.actions.startLoading());
    try {
      const dQPub = await decodeQrcodePublic(rest);
      console.log(dQPub);
      dispatch(slice.actions.getEditInfo(dQPub));
    } catch (error) {
      console.log(error);
      console.log(error.result);
      dispatch(
        slice.actions.setTokenResult({ key: 'first', value: error.result })
      );

      decodeQrcode(rest)
        .then((dQ) => dispatch(slice.actions.getEditInfo(dQ)))
        .catch((err) => {
          console.log(err);
          dispatch(
            slice.actions.setTokenResult({ key: 'second', value: err.result })
          );
        });
    } finally {
      if (callback) {
        callback();
      }
    }
  };
}
